export default {
  parishes: {},
  parishioners: {},
  donationTypes: {},
  donations: {},
  allDonations: {},
  current: null
}
